export default __webpack_public_path__ + "img/07934b4ec72d7fb591b7538b513309ec.png";